import React from 'react';
import MuiBox, { BoxProps as MuiBoxProps } from '@mui/material/Box';

/**
 * Design System Box
 *
 * Transitional layout primitive to keep MUI usage inside DS
 * while we incrementally migrate layout to Tailwind.
 */
export interface BoxProps extends MuiBoxProps {}

const DSBox = React.forwardRef<React.ComponentRef<typeof MuiBox>, BoxProps>(
  function DSBox({ children, ...props }, ref) {
    return (
      <MuiBox ref={ref} {...props}>
        {children}
      </MuiBox>
    );
  },
);

export default DSBox;
